// src/components/Product/ProductFilters.jsx
export default function ProductFilters({
  categories = [],
  occasions = [],
  searchTerm = "",
  selectedCategories = [],
  selectedOccasions = [],
  onSearchChange,
  onCategoryToggle,
  onOccasionToggle,
  onClearFilters,
}) {
  return (
    <div className="filter-bar">
      {/* OCCASION CHECKBOXES */}
      <div className="filter-row">
        <strong>Filter by Occasion:</strong>
        <div className="filter-tags">
          {occasions.map((occ) => (
            <button
              key={occ}
              className={`filter-tag ${selectedOccasions.includes(occ) ? 'active' : ''}`}
              onClick={() => onOccasionToggle(occ)}
            >
              {occ}
            </button>
          ))}
        </div>
      </div>

      {/* CATEGORY CHECKBOXES */}
      <div className="filter-row">
        <strong>Filter by Category:</strong>
        <div className="filter-tags">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-tag ${selectedCategories.includes(cat) ? 'active' : ''}`}
              onClick={() => onCategoryToggle(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

     {/* SEARCH BY TITLE + CLEAR */}
     {/*<div>
       <strong>Search by Title:</strong>
      <div className="filter-row">
          <input
            type="text"
            placeholder="Search by title..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
      </div> 
      </div>*/}
            {/* <div className="search-clear">
        <button onClick={onClearFilters}>Clear Filters</button>
      </div> */}
    </div>
  );
}
